// ./src/utils/api/signupReportCount.ts
//
// Who a guest-signup report counts, as the server is asked (#44 / #46 / #47; statuses — owner 2026-10-10). Pure.

/**
 * Which audience a guest report counts — mirrors QUESTION_REPORT_AUDIENCE on the server. `by_status` is the PAGE's: it
 * is sent as `everyone` + the chosen `rsvpStatuses` (count only those; none chosen = everyone).
 */
export const SIGNUP_REPORT_AUDIENCE = {
  HOLDING_PLACE: "holding_place",
  EVERYONE: "everyone",
  BY_STATUS: "by_status",
} as const;

/** What the server is asked: the audience, and the statuses when the host chose some. */
export const signupReportCountParams = (audience: string, rsvpStatuses: readonly string[] | null | undefined): { audience: string; rsvpStatuses?: string[] } => {
  if (audience === SIGNUP_REPORT_AUDIENCE.BY_STATUS) {
    const chosen = [...(rsvpStatuses ?? [])];

    // ⓘ Sent only when chosen — a gateway older than the field still answers every other read.
    return chosen.length > 0 ? { audience: SIGNUP_REPORT_AUDIENCE.EVERYONE, rsvpStatuses: chosen } : { audience: SIGNUP_REPORT_AUDIENCE.EVERYONE };
  }

  return { audience: audience === SIGNUP_REPORT_AUDIENCE.EVERYONE ? SIGNUP_REPORT_AUDIENCE.EVERYONE : SIGNUP_REPORT_AUDIENCE.HOLDING_PLACE };
};
